import ScratchCard from "./Components/scratchCard.js";
import TeamRecord from "./Components/TeamRecord.js";
import { useLoaderData, useParams, useSearchParams } from "react-router-dom";
import RemoveCanvasButton from "./Components/RemoveCanvasButton";
import VoteButton from "./Components/VoteButton.js";
import DateBrowser from "./Components/DateBrowser.js";
import axios from 'axios';
import { useEffect, useState } from "react";

const WorldCupPage = () =>{
    const sport = "wc2026";
    const { date } = useParams();

    const [searchParams]= useSearchParams();
    const timezone = searchParams.get('tz') ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

    const loaderData = useLoaderData();

    const [gameData, setGameData] = useState(loaderData);

    useEffect(() => {
        setGameData(loaderData);
    }, [loaderData]);


    const statusOrder = {
                    "inprogress" : 0,
                    "notstarted" : 1,
                    "finished": 2
                    };

    const sortedData = [...gameData.externalData].sort((a, b)=>{
        if (a.statusType !== b.statusType){
          return statusOrder[a.statusType] - statusOrder[b.statusType];
        }
        return a.startTimestamp - b.startTimestamp
      });

    const hasLiveGames = sortedData.some(event => event.statusType === "inprogress");

    useEffect(()=>{
      if(!hasLiveGames) return;
      const interval = setInterval( async ()=> {
        const response = await axios.get(`/api/wc2026/${date}?timezone=${encodeURIComponent(timezone)}`);
        setGameData(response.data);
      }, 60000);
      return ()=> clearInterval(interval);
    }, [hasLiveGames]);

return (
    <>
    <div className="sports-page">
      <h1>2026 World Cup Scoreboard</h1>
      <DateBrowser date={date} sport={sport} timezone={timezone}/>
      <RemoveCanvasButton />
      {gameData.message && <h2>{gameData.message}</h2>}
      {sortedData.map(
        ({  id, tournamentName, awayTeam, awayScore, homeTeam, homeScore, startTimestamp, status, statusType, homeRecord, awayRecord, venue, 
           roundName, roundGame, homeTeamSeriesRecord, awayTeamSeriesRecord, homeTeamSeed, awayTeamSeed,
        }) => {

          const gameVotes = gameData.internalData.find(vote => vote.eventID === id);

          const watchWorthyScore = (Math.abs(awayScore - homeScore) <=4 && (awayScore + homeScore) >=200)? 1 : 0 ;
          console.log(watchWorthyScore);

          const borderStyles ={
            "finished": "border-red",
            "inprogress": "border-green"
          }

          const groupGame = tournamentName.replaceAll("FIFA World Cup, ", "");


          return (
            <div className="game-grid">
            <section key={id} className={`game-container ${borderStyles[statusType] ?? ""}`}>
               <div className="teams-row">
                <TeamRecord sport={sport} teamName={awayTeam} record={awayRecord} opponentRecord={homeRecord} seriesRecord={awayTeamSeriesRecord} opponentSeriesRecord={homeTeamSeriesRecord} tournamentName={tournamentName} className={"away-team"} />
                <h1>@</h1>
                <TeamRecord sport={sport} teamName={homeTeam} record={homeRecord} opponentRecord={awayRecord} seriesRecord={homeTeamSeriesRecord} opponentSeriesRecord={awayTeamSeriesRecord} tournamentName={tournamentName} className={"home-team"} />
              </div>
              {/* <h3>{tournamentName === "NBA, Playoffs" && roundName}</h3> */}
              <h3>Group Stage: {groupGame}</h3>
              <h3>Kickoff: {new Date(startTimestamp*1000).toLocaleTimeString([], { hour: "numeric", minute: "numeric"})} | {venue}</h3>
              <h3>{status==="AET" ? "Overtime" : status  }</h3>

                      <div className="grid-container">
                  
                        <VoteButton eventID={id} sport={sport} gameDate={date} gameVotes={{upvotes: gameVotes?.upvotes || 0, downvotes: gameVotes?.downvotes || 0}} className="element-1"/>
                        <div className="scores-section element-2">
                            <ul className="scratchable">
                              <li>
                                <span>{awayTeam}:</span> 
                                <ScratchCard text={awayScore} watchWorthyScore={watchWorthyScore} />
                              </li>
                    
                              <li>
                                <span>{homeTeam}:</span>
                                <ScratchCard text={homeScore} watchWorthyScore={watchWorthyScore} />
                              </li>
                            </ul>
                          </div>
                          <div className="watchworthy element-3">

                          </div>

                      </div>
            </section>
          </div>
        )}
      )}
     </div> 
    </>
  );

}

export default WorldCupPage;